import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface Price {
  priceMin: number;
  priceMax: number;
}

interface SearchState {
  actions: string;
  category: string;
  locations: string;
  price: Price;
}

const initialState: SearchState = {
  actions: '',
  category: '',
  locations: '',
  price: {
    priceMin: 0,
    priceMax: 0,
  },
};

export const mobileSlice = createSlice({
  name: 'mobileValue',
  initialState,
  reducers: {
    addAction: (state, action: PayloadAction<string>) => {
      state.actions = action.payload;
    },
    addCategory: (state, action: PayloadAction<string>) => {
      state.category = action.payload;
    },
    addLocations: (state, action: PayloadAction<string>) => {
      state.locations = action.payload;
    },
    addPrice: (state, action: PayloadAction<Price>) => {
      state.price = action.payload;
    },
  },
});

export const { addAction, addCategory, addLocations, addPrice } = mobileSlice.actions;

export const selectAction = (state: RootState) => state.mobile.actions;
export const selectCategory = (state: RootState) => state.mobile.category;
export const selectLocation = (state: RootState) => state.mobile.locations;
export const selectPrice = (state: RootState) => state.mobile.price;

export default mobileSlice.reducer;
